import React, { useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./NewService.css";
import AlertModal from "./AlertModal";
import { Alert } from "react-bootstrap";
import API_URL from "../config";
import api from "./Api";
import { UserContext } from "../../UserContext";
export default function ReviewService({ k, onClose }) {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const permissions = user?.permission_ids || [];
  const [clientName, setClientName] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [wahName, setwahName] = useState("");
  const [mtattendu, setmtattendu] = useState(0);
  const [blav, setblav] = useState(false);
  const [laveuse, setlaveuse] = useState("");
  const [mtpaye1, setmtpaye1] = useState(0);
  const [mtpaye2, setmtpaye2] = useState(0);
  const [mtremise, setmtremise] = useState(0);
  const [modreglement, setShop1] = useState("Choose Payment Method");
  const [modreglement2, setShop2] = useState("Choose Payment Method");
  const [tresse2, settresse2] = useState(false);
  const [tresse3, settresse3] = useState(false);
  const [mtlav, setmtlav] = useState(0);
  const [clientCode, setClientCode] = useState("");
  const [prixService, setPrixService] = useState(0);
  const [coutMeche, setCoutMeche] = useState(0);
  const [prixWash, setPrixWash] = useState(0);
  const [wahCode, setwahCode] = useState("NON");
  const [tresseuse1, setTresseuse1] = useState("");
  const [tresseuse2, setTresseuse2] = useState("");
  const [tresseuse3, setTresseuse3] = useState("");
  const [codpaielv, setcodpaielv] = useState("");
  const [codtres1, setCodtres1] = useState("NON");
  const [codtres2, setCodtres2] = useState("NON");
  const [codtres3, setCodtres3] = useState("NON");
  const [mttres1, setmttres1] = useState(0);
  const [mttres2, setmttres2] = useState(0);
  const [mttres3, setmttres3] = useState(0);
  const [nbTresseuses, setNbTresseuses] = useState(1);
  const [shop, setShop] = useState("SH1---Shop 1");
  const [ldate, setLdate] = useState("");
  const [serviceSearch, setServiceSearch] = useState([]);
  const [washSearch, setWashSearch] = useState([]);
  const [tres1Search, setTres1Search] = useState([]);
  const [tres2Search, setTres2Search] = useState([]);
  const [tres3Search, setTres3Search] = useState([]);
  const [nbreserv, setNbreserv] = useState(""); // ID réel
  const [idservice, setIdService] = useState(""); // ID réel
  const [idtyservice, setIdtyService] = useState(""); // ID réel
  const [codservice, setCodService] = useState(""); // ID réel
  const [codpaie1, setcodpaie1] = useState("0");
  const [codpaie2, setcodpaie2] = useState("0");
  const [codpaie3, setcodpaie3] = useState("0");
  const [codpaie4, setcodpaie4] = useState("0");
  const [perslav1, setperslav1] = useState(0);
  const [perslav2, setperslav2] = useState(0);
  const [perslav3, setperslav3] = useState(0);
  const [perslav4, setperslav4] = useState(0);
  const [nbserv, setnbserv] = useState(1);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const showModalAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
  };
  const formatDollar = (amount) => {
    if (amount == null) return "$0.00"; // gestion des valeurs nulles
    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const useDebouncedSearch = (searchText, setResults) => {
    useEffect(() => {
      const fetchData = async () => {
        if ((searchText + "").trim() === "") {
          setResults([]);
          return;
        }

        try {
          const res = await axios.get(
            `${API_URL}/search_tresseuse2/${searchText}/`,
          );
          //   alert(res.data);
          setResults(res.data);
        } catch (error) {
          console.error("Erreur lors du chargement :", error);
        }
      };

      const timer = setTimeout(fetchData, 300); // debounce
      return () => clearTimeout(timer);
    }, [searchText, setResults]);
  };
  // --- Appliquer le hook pour chaque champ ---
  useDebouncedSearch(laveuse, setWashSearch);
  useDebouncedSearch(tresseuse1, setTres1Search);
  useDebouncedSearch(tresseuse2, setTres2Search);
  useDebouncedSearch(tresseuse3, setTres3Search);

  // fonction générique
  const handleChange = (e, searchList, setTresseuse, setCodtres) => {
    const value = e.target.value.toUpperCase();
    setTresseuse(value);

    const selected = searchList.find(
      (tres) => `${tres.nomtres} (${tres.numcode})`.toUpperCase() === value,
    );

    if (selected) {
      setCodtres(selected.codtres);
    }
  };

  // Convertir k en nom client
  useEffect(() => {
    if (k) {
      const parts = k.split("@@");
      setClientName(parts[0] + "---" + parts[1]);
      setLdate(parts[4]);
      setNbreserv(parts[2]);
      setClientCode(parts[0]);
    }
  }, [k]);
  const handleSelect = (e) => {
    const selected = serviceSearch.find((s) =>
      e.target.value.startsWith(s.nomtypt),
    );
    if (selected) {
      setPrixService(selected.prix);
      setServiceName(selected.nomtypt); // optionnel si tu veux garder juste le nom
      setIdtyService(selected.codtypt);
    }
  };

  useEffect(() => {
    if (nbreserv && clientCode) {
      ChargeInfoClientService(nbreserv, clientCode, ldate, {
        setServiceName,
        setPrixService,
        setlaveuse,
        setNbTresseuses,
        setTresseuse1,
        setTresseuse2,
        setTresseuse3,
        setwahName,
        setCodtres1,
        setCodtres2,
        setCodtres3,
        setwahCode,
        setIdService,
        setIdtyService,
        setCodService,
        setPrixWash,
        settresse2,
        settresse3,
        setblav,
        setmttres1,
        setmtremise,
        setmttres2,
        setmtattendu,
        setmttres3,
        setmtlav,
        setcodpaielv,
        setShop1,
        setShop2,
        setmtpaye1,
        setmtpaye2,
        setCoutMeche,
        setcodpaie1,
        setcodpaie2,
        setcodpaie3,
        setcodpaie4,
        setperslav1,
        setperslav2,
        setperslav3,
        setperslav4,
      });
    }
  }, [nbreserv, clientCode, ldate]);

  const ChargeInfoClientService = async (codserv, codclt, ldate, setters) => {
    //   alert(ldate);
    try {
      const res = await axios.post(`${API_URL}/info-client-review/`, {
        mat: codserv,
        lclts: codclt,
        ldate: ldate,
      });

      const { service, tresseuses, reglement } = res.data;
      //alert(tresseuses.length);
      setters.setCodService(service.codeserv);
      setters.setIdService(service.idserv);
      setters.setIdtyService(service.code);
      setters.setServiceName(service.name);
      setters.setCoutMeche(service.prix_meche);
      const prixWash2 = Number(service.prix_wash) || 0;
      const prixservic = Number(service.prix_service) || 0;
      const prixmeche = Number(service.prix_meche) || 0;
      const prixsrv = prixservic - prixWash2 - prixmeche;

      // setters.setTresseuse1(reglement[0].idreg);
      setters.setPrixService(prixsrv);
      setters.setmtattendu(prixservic);
      setters.setPrixWash(service.prix_wash);

      if (reglement[0].modes_paiement.length === 2) {
        const mp1 = reglement[0].modes_paiement[0];
        const mp2 = reglement[0].modes_paiement[1];
        setters.setShop1(mp1.mode);
        setters.setmtpaye1(mp1.montant);
        setters.setShop2(mp2.mode);
        setters.setmtpaye2(mp2.montant);
      } else {
        const mp1 = reglement[0].modes_paiement[0];
        setters.setShop1(mp1.mode);
        setters.setmtpaye1(mp1.montant);
      }
      // Gestion tresseuses
      // 🔍 Y a-t-il une laveuse ?
      const laveuse = tresseuses.find((t) => Number(t.perslav) === 1);
      const tresseusesNormales = tresseuses.filter(
        (t) => Number(t.perslav) !== 1,
      );

      // ==========================
      // Fonctions utilitaires
      // ==========================
      const setTresseuse = (index, t) => {
        setters[`setTresseuse${index}`](`${t.name} (${t.code})`);
        setters[`setCodtres${index}`](t.codeid);
        setters[`setmttres${index}`](t.mtpaie);
        setters[`setcodpaie${index}`](t.codpaie);
        setters[`setperslav${index}`](t.perslav);
      };
      // setters[`setcodpaie${index}`](t.codpaie);
      const setLaveuse = (t) => {
        setters.setblav(true);
        setters.setlaveuse(`${t.name} (${t.code})`);
        setters.setwahCode(t.codeid);
        setters.setmtlav(t.mtpaie);
        setters.setcodpaielv(t.codpaie);
        setters[`setcodpaie4`](t.codpaie);
        setters[`setperslav4`](t.perslav);
      };

      // ==========================
      // Appliquer la laveuse
      // ==========================
      if (laveuse) {
        setLaveuse(laveuse);
      }

      // ==========================
      // Appliquer les tresseuses
      // ==========================
      tresseusesNormales.forEach((t, index) => {
        const pos = index + 1;
        setTresseuse(pos, t);

        if (pos > 1) {
          setters[`settresse${pos}`](true);
        }
      });
    } catch (error) {
      console.error("Erreur chargement service :", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (serviceName.trim() === "") {
        setServiceSearch([]);
        return;
      }

      try {
        const res = await axios.get(
          `${API_URL}/search_type_by_name/${serviceName}/`,
        );
        setServiceSearch(res.data);
      } catch (error) {
        console.error("Erreur lors du chargement :", error);
      }
    };

    // petit délai (debounce) pour éviter trop de requêtes pendant la saisie
    const timer = setTimeout(fetchData, 300);
    return () => clearTimeout(timer);
  }, [serviceName]);

  useEffect(() => {
    const sum =
      Number(prixService) +
      Number(coutMeche) +
      Number(prixWash) -
      Number(mtremise);

    setmtattendu(sum);
  }, [prixService, coutMeche, prixWash]);

  useEffect(() => {
    const service = Number(prixService);
    const meche = Number(coutMeche);
    const wash = Number(prixWash);
    const remise = Number(mtremise);

    const ctreel = service + meche + wash - remise;
    const paid = Number(mtpaye1) + Number(mtpaye2);

    const surplus = Math.max(0, paid - ctreel);
    const lpart = surplus / nbTresseuses;

    // reset (important)
    //  setmttres1(0);
    //   setmttres2(0);
    //  setmttres3(0);
    //  setmtlav(0);
    /*
    if (nbTresseuses === 1) {
      setmttres1(lpart + service / 2);
    } else if (nbTresseuses === 4) {
      const paie = lpart + service / 6;
      setmttres1(paie);
      setmttres2(paie);
      setmttres3(paie);
      setmtlav(lpart + wash / 2);
    } else if (nbTresseuses === 2) {
      if (blav) {
        setmttres1(lpart + service / 2);
        setmtlav(lpart + wash / 2);
      } else {
        const paie = lpart + service / 4;
        setmttres1(paie);
        setmttres2(paie);
      }
    } else {
      // 3 tresseuses
      if (blav) {
        const paie = lpart + service / 4;
        setmttres1(paie);
        setmttres2(paie);
        setmtlav(lpart + wash / 2);
      } else {
        const paie = lpart + service / 6;
        setmttres1(paie);
        setmttres2(paie);
        setmttres3(paie);
      }
    }  */
  }, [
    prixService,
    coutMeche,
    prixWash,
    mtremise,
    mtpaye1,
    mtpaye2,
    nbTresseuses,
    blav,
  ]);

  const saveService = async () => {
    try {
      const payload = {
        client: clientName,
        service: idservice,
        prixService,
        mtlav,
        mtpaye1,
        mtpaye2,
        modreglement,
        modreglement2,
        mtattendu,
        mttres1,
        mttres2,
        mttres3,
        mtremise,
        coutMeche,
        prixWash,
        tresseuse1: codtres1,
        tresseuse2: codtres2,
        tresseuse3: codtres3,
        nbTresseuses,
        nbreserv,
        shop,
        ldate,
        wahName: wahCode,
        nbserv,
        codservice,
        codpaie1,
        codpaie2,
        codpaie3,
        codpaie4,
        idtyservice,
      };
      const response = await api.post("update_review_service/", payload);

      //  console.log(response.data);

      /*  const response = await axios.post(
        `${API_URL}/update_review_service/`,
        payload,
      );*/

      showModalAlert("Save succesfully ✔");

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement !");
    }
  };

  const validService = async () => {
    try {
      const payload = {
        service: idservice,
        nbreserv,
      };
      const response = await api.post("update_statut_review/", payload);

      // console.log(response.data);

      /*  const response = await axios.post(
        `${API_URL}/update_statut_review/`,
        payload,
      );*/

      showModalAlert("Update succesfully ✔");

      onClose();
      console.log(response.data);
    } catch (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement !");
    }
  };

  return (
    <div className="container-box">
      <div className="card9" style={{ padding: "20px" }}>
        <h3>REVIEW A SERVICE</h3>

        <div className="row3">
          <div className="col-lg-3 col-md-3">
            <label className="field-label">Nom du client</label>
            <input value={clientName} disabled className="input" />
          </div>
          <div className="col-lg-4 col-md-4">
            <label className="field-label">Service / Hairstyle Name</label>
            <input
              type="text"
              placeholder="Enter the name of the hairstyle"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
              onSelect={handleSelect}
              className="input"
              list="groupDatalistr"
            />

            <datalist id="groupDatalistr">
              {(Array.isArray(serviceSearch) ? serviceSearch : []).map(
                (tres) => (
                  <option
                    key={tres.codtypt}
                    value={`${tres.nomtypt} - (${formatDollar(tres.prix)})`}
                  />
                ),
              )}
            </datalist>
          </div>

          <div className="col-lg-1 col-md-1">
            <label className="field-label">Srv</label>
            <input
              type="number"
              placeholder="0"
              value={prixService}
              onChange={(e) => setPrixService(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Cost Srv</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(prixService))}
              disabled
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Awaited amount</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(mtattendu))}
              disabled
              className="input"
            />
          </div>
        </div>

        <div className="row3">
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Military discount</label>
            <input
              value={mtremise}
              onChange={(e) => setmtremise(e.target.value)}
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Mèches</label>
            <input
              type="number"
              value={coutMeche}
              onChange={(e) => setCoutMeche(e.target.value)}
              className="input"
              placeholder="Coût mèche"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Mèches</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(coutMeche))}
              disabled
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Wash</label>

            <input
              type="number"
              value={prixWash}
              onChange={(e) => setPrixWash(e.target.value)}
              className="input"
              placeholder="Coût lavage"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Wash</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(prixWash))}
              disabled
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Expected amount</label>
            <input
              value={formatDollar(Number(prixService))}
              disabled
              className="input"
            />
          </div>
        </div>
        <div className="row3">
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Payment Mode 1</label>
            <select
              value={modreglement}
              onChange={(e) => setShop1(e.target.value)}
              className="input"
            >
              <option>Choose Payment Method</option>
              <option>Cash</option>
              <option>Cashapp</option>
              <option>Venmo</option>
              <option>Zelle</option>
              <option>Credit card</option>
            </select>
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 1</label>
            <input
              type="number"
              placeholder="0"
              value={mtpaye1}
              onChange={(e) => setmtpaye1(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 1</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(mtpaye1))}
              disabled
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Payment Mode 2</label>
            <select
              value={modreglement2}
              onChange={(e) => setShop2(e.target.value)}
              className="input"
            >
              <option>Choose Payment Method</option>
              <option>Cash</option>
              <option>Cashapp</option>
              <option>Venmo</option>
              <option>Zelle</option>
              <option>Credit card</option>
            </select>
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 2</label>
            <input
              type="number"
              placeholder="0"
              value={mtpaye2}
              onChange={(e) => setmtpaye2(e.target.value)}
              className="input"
            />
          </div>

          <div className="col-lg-2 col-md-2">
            <label className="field-label">Amount Paid 2</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(mtpaye2))}
              disabled
              className="input"
            />
          </div>
        </div>

        <h4>Determining the Service Prices of Braiders</h4>

        {blav && (
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <label className="field-label">
                Braider who also performed the wash
              </label>

              <input
                placeholder="Choose the braider"
                value={laveuse}
                onChange={(e) =>
                  handleChange(e, washSearch, setlaveuse, setwahCode)
                }
                className="input"
                list="grouptrewashr"
              />

              <datalist id="grouptrewashr">
                {(Array.isArray(washSearch) ? washSearch : []).map((tres) => (
                  <option
                    key={tres.codtres}
                    value={`${tres.nomtres} (${tres.numcode})`}
                    data-codtres={tres.codtres}
                  />
                ))}
              </datalist>
            </div>

            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mtlav}
                onChange={(e) => setmtlav(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mtlav))}
                disabled
                className="input"
              />
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-lg-3 col-md-3">
            <label className="field-label">First Braider</label>

            <input
              placeholder="Choose the first braider"
              value={tresseuse1}
              onChange={(e) =>
                handleChange(e, tres1Search, setTresseuse1, setCodtres1)
              }
              className="input"
              list="grouptres1r"
            />

            <datalist id="grouptres1r">
              {(Array.isArray(tres1Search) ? tres1Search : []).map((tres) => (
                <option
                  key={tres.codtres}
                  value={`${tres.nomtres} (${tres.numcode})`}
                  data-codtres={tres.codtres}
                />
              ))}
            </datalist>
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Allocated Amount</label>
            <input
              type="number"
              placeholder="0"
              value={mttres1}
              onChange={(e) => setmttres1(e.target.value)}
              className="input"
            />
          </div>
          <div className="col-lg-2 col-md-2">
            <label className="field-label">Allocated Amount</label>
            <input
              type="text"
              placeholder="0"
              value={formatDollar(Number(mttres1))}
              disabled
              className="input"
            />
          </div>
        </div>

        {tresse2 && (
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <label className="field-label">Second Braider</label>
              <input
                placeholder="Choose the second braider "
                value={tresseuse2}
                onChange={(e) =>
                  handleChange(e, tres2Search, setTresseuse2, setCodtres2)
                }
                className="input"
                list="grouptres2r"
              />

              <datalist id="grouptres2r">
                {(Array.isArray(tres2Search) ? tres2Search : []).map((tres) => (
                  <option
                    key={tres.codtres}
                    value={`${tres.nomtres} (${tres.numcode})`}
                    data-codtres={tres.codtres}
                  />
                ))}
              </datalist>
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mttres2}
                onChange={(e) => setmttres2(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mttres2))}
                disabled
                className="input"
              />
            </div>
          </div>
        )}

        {tresse3 && (
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <label className="field-label">Third Braider</label>
              <input
                placeholder="Choose the third braider"
                value={tresseuse3}
                onChange={(e) =>
                  handleChange(e, tres3Search, setTresseuse3, setCodtres3)
                }
                className="input"
                list="grouptres3r"
              />

              <datalist id="grouptres3r">
                {(Array.isArray(tres3Search) ? tres3Search : []).map((tres) => (
                  <option
                    key={tres.codtres}
                    value={`${tres.nomtres} (${tres.numcode})`}
                    data-codtres={tres.codtres}
                  />
                ))}
              </datalist>
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="number"
                placeholder="0"
                value={mttres3}
                onChange={(e) => setmttres3(e.target.value)}
                className="input"
              />
            </div>
            <div className="col-lg-2 col-md-2">
              <label className="field-label">Allocated Amount</label>
              <input
                type="text"
                placeholder="0"
                value={formatDollar(Number(mttres3))}
                disabled
                className="input"
              />
            </div>
          </div>
        )}

        <div className="row">
          <button
            className="btn"
            onClick={saveService}
            disabled={!permissions.includes(32)}
          >
            Update and validate
          </button>
          <button
            className="btn red"
            onClick={() => {
              if (onClose) onClose();
            }}
          >
            Cancel
          </button>
          <button
            className="btn"
            onClick={validService}
            disabled={!permissions.includes(32)}
          >
            Validate
          </button>
        </div>
      </div>
      <AlertModal
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </div>
  );
}
